export default __webpack_public_path__ + "static/media/loh_licensing_crown.9d2af053.svg";